import { createBrowserHistory, createHashHistory } from 'history'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { Provider } from 'react-redux'
import './assets/styles/main.scss'
import { BrowserRouter } from 'react-router-dom'

import { analytics } from 'analytics/index'
import config from 'config'
import { isNil, isNotNil } from 'core/service/lib/type-check'
import { createServiceWrapper } from 'core/service-wrapper'
import { loadConfig, getAppConfig } from 'deploy-env/app-config'
import { instance } from 'e-submission/domain/data/request-wrapper'
import esubStore from 'e-submission/store'
import { workaroundCordovaKeyboardDidHide } from 'lib/cordova-util'
import { appFailedSecurityPolicy, initialiseApplicationRequest } from 'quick-quote/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import { sagaMiddleware, store } from 'store'

import { createUserManager, saga as identitySaga } from './identity'
import { MainContainer, rootSaga } from './quick-quote'

export const bootstrap = () =>
  new Promise((resolve) => {
    if (window.cordova) {
      /* istanbul ignore next */
      document.addEventListener('deviceready', resolve, false)
    } else {
      resolve()
    }
  })
/* istanbul ignore next */
window.isRooted = () => {
  return new Promise((resolve, reject) => {
    window.IRoot.isRootedRedBeer(
      (result) => {
        if (result === true || result === 1) {
          resolve(true)
        } else resolve(false)
      },
      (error) => {
        reject(error)
      }
    )
  })
}
/* istanbul ignore next */
export const securityCheck = () =>
  new Promise((resolve, reject) => {
    if (window.cordova) {
      window
        .isRooted()
        .then((isDeviceRootedOrJailbroken) => {
          if (isDeviceRootedOrJailbroken) {
            store.dispatch(appFailedSecurityPolicy())
            reject()
          } else resolve()
        })
        .catch(() => {
          store.dispatch(appFailedSecurityPolicy())
          reject()
        })
    } else resolve()
  })

const basePath = process.env.BASE_PATH
const history = window.cordova
  ? createHashHistory({ basename: basePath })
  : createBrowserHistory({ basename: basePath })

const render = (Component) =>
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <BrowserRouter>
          <Component history={history} />
        </BrowserRouter>
      </Provider>
    </AppContainer>,
    document.getElementById('app')
  )

bootstrap()
  //  .then(securityCheck)
  .then(loadConfig)
  .then(async (configJSON) => {
    analytics.initialiseGA(getAppConfig().GA_TRACKING_ID)
    if (getToggles().ENABLE_AUTHORISATION_CODE_FLOW) {
      instance.interceptors.request.use((config) => ({
        ...config,
        withCredentials: true,
        crossDomain: true,
      }))
    }

    const serviceWrapper = await createServiceWrapper()
    const userManager = createUserManager(configJSON)
    sagaMiddleware.run(rootSaga, serviceWrapper, userManager, esubStore, history)
    sagaMiddleware.run(identitySaga, userManager, store)
    store.dispatch(initialiseApplicationRequest(config.iConnectDb.localURL))
  })
  .then(() => import(/* webpackChunkName: "e-submission" */ 'e-submission'))
  .then(({ initEsubmission }) => initEsubmission(store, history))
  .then(() => {
    render(MainContainer)
  })
  .then(() => {
    workaroundCordovaKeyboardDidHide()
  })
  .catch((e) => {
    console.error(e)
    location.reload()
  })
/* istanbul ignore next */
if (module.hot) {
  module.hot.accept('./quick-quote', () => render(MainContainer))
  module.hot.accept('./e-submission', () => render(MainContainer))
  module.hot.accept('./e-submission/app', () => render(MainContainer))
  module.hot.accept('./e-submission/domain/data/request-wrapper', () => render(MainContainer))
  module.hot.accept('./identity', () => render(MainContainer))
  module.hot.accept('./analytics', () => render(MainContainer))
}
/* istanbul ignore next */
const onDefocusActiveElement = (event) => {
  if (isNil(document.activeElement)) return

  const element = event.target
  const elementTagName = element.nodeName
  /* istanbul ignore next */
  const canContinueFocusing =
    elementTagName === 'INPUT' &&
    isNotNil(element.attributes) &&
    isNil(element.attributes.readonly) &&
    isNil(element.attributes.disabled)
  if (canContinueFocusing) return
  /* istanbul ignore next */
  if (isNotNil(document.activeElement.blur)) {
    document.activeElement.blur()
  }
}

document.body.addEventListener('touchstart', onDefocusActiveElement)
